export default __webpack_public_path__ + "static/media/Padron_DeliciasClosed.635725c6.jpg";